module.exports = __webpack_public_path__ + "img/PS40.13bdc194.png";